// extracted by mini-css-extract-plugin
export var closeButton = "_45-3";
export var header = "_45-0";
export var link = "_45-1";
export var retryButton = "_45-2";